import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { Chip } from '@mint-lib/tw-components';

import { getDocumentStatus } from '../../../../helpers/ragDocumentStatus.js';
import { RagTableType } from '../../../../types/rag.js';

const StatusCell = ({ data }: ICellRendererParams<RagTableType>) => {
  if (!data?.status) {
    return null;
  }

  const currStatus = getDocumentStatus(data.status);

  return (
    <Chip variant="outline" size="small" color={currStatus.color}>
      <p className="capitalize">{currStatus.label}</p>
    </Chip>
  );
};

export { StatusCell };
